<div
	class="tw-rounded-[15px] tw-bg-white tw-shadow-lg tw-p-1  tw-h-56 tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full">
	<div *ngIf="!iconImage"
		class="tw-w-full tw-flex tw-justify-center">
		<i [ngClass]="iconClass"
			class="fa tw-mb-4  tw-text-6xl"
			*ngIf="!isLoading"></i>
	</div>
	<div *ngIf="iconImage" >
		<img [src]="iconImage"
			class="tw-mb-[18px]"
			[ngClass]="iconClass"
			*ngIf="!isLoading">
	</div>
	<div *ngIf="isLoading"
		class="tw-h-24 tw-w-24 tw-bg-gray-200 tw-rounded-full tw-animate-pulse">
	</div>
	<h2 *ngIf="isLoading"
		class="tw-h-5 mb-1 tw-w-24 tw-bg-gray-200 tw-rounded-full tw-animate-pulse">
	</h2>
	<h2 *ngIf="!isLoading"
		class="tw-text-4xl  tw-font-bold tw-mb-2">
		{{statValue || 0}} </h2>
	<div
		class="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-break-words tw-text-center">
		<p *ngIf="!isLoading"
			class="tw-font-medium tw-text-gray-500 md:tw-text-base tw-text-xs">
			{{ statDescription }}
		</p>
		<div *ngIf="isLoading"
			class=" tw-h-4 tw-bg-gray-200 tw-rounded tw-animate-pulse tw-w-2/4">
		</div>
	</div>
</div>


